module.exports = __webpack_public_path__ + "static/media/grid-item-a1.fc8838bc.png";